import AsyncSelect from 'react-select/async';
import { getRandomUid } from 'utilities/uuid.service';
import { useContext, useEffect, useMemo, useState } from 'react';
import useCourses from 'hooks/API/GET/useCourses';
import useDebounce from 'hooks/useDebounce';
import { FetchContext } from 'context/FetchContext';
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';

function CoursesSearch({
  enableAPI,
  isMulti,
  values,
  handleChange,
  dependencies = {},
  labelClass = `*`,
}) {
  const { query = {} } = dependencies;
  const [courses, setCourses] = useState([]);
  const [search, setSearch] = useState('');
  const [keyword, setKeyword] = useState('');

  // const fetchContext = useContext(FetchContext);
  // const { privateFetch } = fetchContext;

  const _id = getRandomUid();

  const { data, isLoading } = useCourses({
    enabled: enableAPI,
    configs: { params: { mode: 'dropdown', keyword, ...query } },
  });

  useEffect(() => {
    if (data?.data) setCourses(data?.data || []);

    return () => {};
  }, [data?.data]);

  const __search = useDebounce(search, 1000);

  useEffect(() => {
    if (__search) setKeyword(__search);
  }, [__search]);

  return (
    <>
      <label htmlFor={_id} className={`${labelClass}`}>
        Courses *
      </label>
      <AsyncTypeahead
        id={_id}
        // filterBy={() => true}
        isLoading={isLoading}
        labelKey="courseName"
        minLength={1}
        onSearch={(query) => setSearch(query)}
        options={courses}
        placeholder="Search courses..."
        selected={values}
        onChange={handleChange}
        renderMenuItemChildren={(option) => <>{option.courseName}</>}
        useCache={false}
      />
    </>
  );
}

CoursesSearch.defaultProps = {
  values: [],
  isMulti: false,
  handleChange: () => {},
};

export default CoursesSearch;
